import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { ControlledTextField, AsyncSelect } from 'src/components/forms'
import { SectionBox } from 'src/pages/sistema/components/FieldView'
import { OperacionNOTESFields } from '../types/fields'
import CardActions from '../../../components/CardActions'
import { OpcionSiNo, useSiNoOptions } from '../../adcm/hooks/useOpcionesGenericas'

interface SeccionNOTESNuevoRescateAnticipadoProps {
  formMethods: UseFormReturn<any>
}

const SeccionNOTESNuevoRescateAnticipado = ({ formMethods }: SeccionNOTESNuevoRescateAnticipadoProps) => {
  const { control, setValue, trigger } = formMethods
  const loadSiNo = useSiNoOptions()

  const watchedTieneRescate = useWatch({ control, name: OperacionNOTESFields.TieneRescateAnticipado })

  useEffect(() => {
    if (watchedTieneRescate === OpcionSiNo.No) {
      setValue(OperacionNOTESFields.BarreraRescateAnticipado, '')
      setValue(OperacionNOTESFields.CondicionRescateAnticipado, '')
      setValue(OperacionNOTESFields.FrecuenciaObservacion, '')
      setValue(OperacionNOTESFields.ObsRescateAnticipado, '')
    }
    if (watchedTieneRescate === OpcionSiNo.Si) {
      trigger([
        OperacionNOTESFields.BarreraRescateAnticipado,
        OperacionNOTESFields.CondicionRescateAnticipado,
        OperacionNOTESFields.FrecuenciaObservacion
      ])
    }
  }, [watchedTieneRescate, setValue, trigger])

  return (
    <CardActions title='Sección Rescate Anticipado' icon='mdi:calendar-remove-outline' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label='¿Tiene rescate anticipado?'
            name={OperacionNOTESFields.TieneRescateAnticipado}
            loadOptions={loadSiNo}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>

        {watchedTieneRescate === OpcionSiNo.Si && (
          <>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Barrera de rescate anticipado' 
                name={OperacionNOTESFields.BarreraRescateAnticipado} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Condición de rescate anticipado' 
                name={OperacionNOTESFields.CondicionRescateAnticipado} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Frecuencia de observación' 
                name={OperacionNOTESFields.FrecuenciaObservacion} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Observaciones adicionales' 
                name={OperacionNOTESFields.ObsRescateAnticipado} 
                control={control} 
                fullWidth 
                multiline 
                rows={2} 
              />
            </Grid>
          </>
        )}
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNOTESNuevoRescateAnticipado